/* Haus of Mx — focused QA fixes 2026-08-26 v6.6.
 * Loaded after v5. Footer behaviour is preserved; marquee fill is rebuilt. */
(function(){
  if(window.__mxUxV66Ready)return;
  window.__mxUxV66Ready=true;

  var SUPPORTED=['en','es','fr','de'];
  var marqueeState=new WeakMap();

  function cleanLocale(code){
    code=String(code||'en').toLowerCase().split('-')[0];
    return SUPPORTED.indexOf(code)>-1?code:'en';
  }

  function routeForLocale(code){
    code=cleanLocale(code);
    var base=location.pathname.replace(/^\/(?:es|fr|de)(?=\/|$)/i,'')||'/';
    if(base.charAt(0)!=='/')base='/'+base;
    var path=(code==='en'?'':'/'+code)+base;
    if(!path)path='/';
    if(path==='/es'||path==='/fr'||path==='/de')path+='/';
    return path+location.search+location.hash;
  }

  function prepareLocalizationForm(form,code){
    if(!form)return;
    code=cleanLocale(code);
    var hiddenLang=form.querySelector('input[name="language_code"]');
    if(hiddenLang)hiddenLang.value=code;
    var ret=form.querySelector('input[name="return_to"]');
    if(!ret){ret=document.createElement('input');ret.type='hidden';ret.name='return_to';form.appendChild(ret);}
    ret.value=routeForLocale(code);
  }

  function nearestLocalizationForm(node){
    if(!node)return null;
    var form=node.closest&&node.closest('form.localization-form');
    if(form)return form;
    var host=node.closest&&node.closest('localization-form');
    return host?host.querySelector('form.localization-form'):null;
  }

  document.addEventListener('change',function(event){
    var control=event.target;
    if(!(control instanceof HTMLSelectElement))return;
    var form=nearestLocalizationForm(control);
    if(!form||!form.querySelector('input[name="language_code"]'))return;
    prepareLocalizationForm(form,cleanLocale(control.value));
  },true);

  document.addEventListener('click',function(event){
    var option=event.target.closest&&event.target.closest('[data-value]');
    if(!option)return;
    var raw=String(option.dataset.value||'').toLowerCase().split('-')[0];
    if(SUPPORTED.indexOf(raw)===-1)return;
    var form=nearestLocalizationForm(option);
    if(!form||!form.querySelector('input[name="language_code"]'))return;
    prepareLocalizationForm(form,raw);
  },true);

  function setImportant(el,prop,value){
    if(!el||!el.style)return;
    if(el.style.getPropertyValue(prop)===value&&el.style.getPropertyPriority(prop)==='important')return;
    el.style.setProperty(prop,value,'important');
  }

  function parseColor(value){
    var m=String(value||'').match(/rgba?\(\s*([\d.]+)[,\s]+([\d.]+)[,\s]+([\d.]+)(?:\s*[,\/]\s*([\d.]+))?/i);
    if(!m)return null;
    return {r:+m[1],g:+m[2],b:+m[3],a:m[4]===undefined?1:+m[4]};
  }

  function luminance(c){return c?(c.r*.299+c.g*.587+c.b*.114):0;}
  function isLightColor(c){return !!(c&&c.a>=.15&&luminance(c)>205);}

  function composedParent(el){
    if(!el)return null;
    if(el.parentElement)return el.parentElement;
    var root=el.getRootNode&&el.getRootNode();
    return root&&root.host?root.host:null;
  }

  function composedClosest(el,selector,stop){
    var node=el;
    while(node&&node!==stop){
      if(node.matches&&node.matches(selector))return node;
      node=composedParent(node);
    }
    return null;
  }

  function effectiveBackground(el,stop){
    var node=el;
    while(node&&node!==stop&&node!==document.documentElement){
      try{
        var c=parseColor(getComputedStyle(node).backgroundColor);
        if(c&&c.a>=.15)return c;
      }catch(e){}
      node=composedParent(node);
    }
    return null;
  }

  function hasOwnText(el){
    if(!el||!el.childNodes)return false;
    for(var i=0;i<el.childNodes.length;i++){
      var n=el.childNodes[i];
      if(n.nodeType===Node.TEXT_NODE&&String(n.nodeValue||'').trim())return true;
    }
    return false;
  }

  function collectRoots(root,roots){
    roots=roots||[];
    if(!root||roots.indexOf(root)>-1)return roots;
    roots.push(root);
    var els=root.querySelectorAll?root.querySelectorAll('*'):[];
    for(var i=0;i<els.length;i++)if(els[i].shadowRoot)collectRoots(els[i].shadowRoot,roots);
    return roots;
  }

  function isJudgeControl(el,wrap){return !!composedClosest(el,'.jm-mfp-close,.jm-mfp-arrow',wrap);}
  function isJudgeStar(el,wrap){return !!composedClosest(el,'.jdgm-star,[class*="star"]',wrap);}
  function isMediaOrSvg(el){return !!(el&&el.matches&&el.matches('img,picture,video,source,svg,path,defs,linearGradient,stop'));}

  function rightReadingPaneFallback(el,wrap){
    if(!hasOwnText(el))return false;
    var content=wrap.querySelector('.jm-mfp-content')||wrap.querySelector('.jm-mfp-container')||wrap;
    if(!content||!content.getBoundingClientRect)return false;
    var cr=content.getBoundingClientRect();
    var r=el.getBoundingClientRect();
    if(cr.width<500||r.width<=0||r.height<=0)return false;
    if(r.right<=cr.left||r.left>=cr.right)return false;
    var text=parseColor(getComputedStyle(el).color);
    if(!text||text.a<.15||luminance(text)<175)return false;
    return (r.left+r.right)/2 >= cr.left+cr.width*.48;
  }

  function forceInkPath(el,wrap){
    var node=el,depth=0;
    while(node&&node!==wrap&&depth<8){
      if(node.style)setImportant(node,'opacity','1');
      var c=null;
      try{c=parseColor(getComputedStyle(node).backgroundColor);}catch(e){}
      if(c&&c.a>=.15)break;
      node=composedParent(node);depth++;
    }
  }

  function paintJudgeRoot(root,wrap){
    if(!root||!root.querySelectorAll)return;
    var nodes=root.querySelectorAll('*');
    for(var i=0;i<nodes.length;i++){
      var el=nodes[i];
      if(isMediaOrSvg(el)||isJudgeControl(el,wrap))continue;
      var bg=effectiveBackground(el,wrap);
      if(!(isLightColor(bg)||rightReadingPaneFallback(el,wrap)))continue;
      forceInkPath(el,wrap);
      setImportant(el,'opacity','1');
      if(isJudgeStar(el,wrap)){
        setImportant(el,'color','#f7e600');
        setImportant(el,'-webkit-text-fill-color','#f7e600');
      }else{
        setImportant(el,'color','#161616');
        setImportant(el,'-webkit-text-fill-color','#161616');
        setImportant(el,'text-shadow','none');
      }
    }
  }

  function normalizeJudgeClose(wrap){
    var close=wrap&&wrap.querySelector('.jm-mfp-close');
    if(!close)return;
    close.classList.remove('mx-judge-close-fixed');
    ['position','top','left','right','bottom','z-index'].forEach(function(prop){close.style.removeProperty(prop);});
  }

  function paintJudge(wrap){
    if(!wrap)return;
    var roots=collectRoots(wrap,[]);
    for(var i=0;i<roots.length;i++)paintJudgeRoot(roots[i],wrap);
    normalizeJudgeClose(wrap);
  }

  function queueJudgePaint(wrap){
    if(!wrap||wrap.__mxJudgeQueued)return;
    wrap.__mxJudgeQueued=true;
    requestAnimationFrame(function(){wrap.__mxJudgeQueued=false;paintJudge(wrap);ensureJudgeObservers(wrap);});
  }

  function ensureJudgeObservers(wrap){
    if(!wrap)return;
    var roots=collectRoots(wrap,[]);
    for(var i=0;i<roots.length;i++){
      var root=roots[i];
      if(root.__mxJudgeObserver)continue;
      var observer=new MutationObserver((function(activeWrap){return function(){queueJudgePaint(activeWrap);};})(wrap));
      observer.observe(root,{childList:true,subtree:true,attributes:true,attributeFilter:['style','class']});
      root.__mxJudgeObserver=observer;
    }
  }

  function ensureJudge(wrap){if(wrap){paintJudge(wrap);ensureJudgeObservers(wrap);}}
  function fixJudge(){var wraps=document.querySelectorAll('.jm-mfp-wrap');for(var i=0;i<wraps.length;i++)ensureJudge(wraps[i]);}

  /* True seamless fill: the original Liquid has only one short phrase set per
     half, so on wide screens the track is physically shorter than the viewport.
     Build TWO identical halves, each wider than the viewport. The existing
     -50% animation then loops at an identical seam with no blank interval. */
  function fixCustomMarquee(){
    var tracks=document.querySelectorAll('[class*="ai-marquee-viewport-"] [class*="ai-marquee-track-"]');
    for(var i=0;i<tracks.length;i++){
      var track=tracks[i];
      var groups=Array.prototype.filter.call(track.children,function(el){return el.matches&&el.matches('[class*="ai-marquee-content-"]');});
      if(groups.length!==2)continue;

      var state=marqueeState.get(track);
      if(!state){
        var firstSeps=groups[0].querySelectorAll('[class*="ai-marquee-separator-"]');
        var secondSeps=groups[1].querySelectorAll('[class*="ai-marquee-separator-"]');
        if(firstSeps.length===secondSeps.length+1&&firstSeps.length){
          groups[1].appendChild(firstSeps[firstSeps.length-1].cloneNode(true));
        }
        var base=groups[0].innerHTML;
        groups[0].innerHTML=base;
        groups[1].innerHTML=base;
        setImportant(groups[0],'flex-shrink','0');
        setImportant(groups[1],'flex-shrink','0');
        setImportant(groups[0],'width','max-content');
        setImportant(groups[1],'width','max-content');
        var baseWidth=Math.max(1,Math.ceil(groups[0].scrollWidth||groups[0].getBoundingClientRect().width));
        state={base:base,baseWidth:baseWidth,repeats:0};
        marqueeState.set(track,state);
      }

      var viewport=track.closest('[class*="ai-marquee-viewport-"]');
      var visibleWidth=Math.max(window.innerWidth,viewport?viewport.clientWidth:0);
      var target=visibleWidth+state.baseWidth;
      var repeats=Math.max(2,Math.ceil(target/state.baseWidth));
      if(repeats!==state.repeats){
        var html='';
        for(var r=0;r<repeats;r++)html+=state.base;
        groups[0].innerHTML=html;
        groups[1].innerHTML=html;
        state.repeats=repeats;
        var animations=track.getAnimations?track.getAnimations():[];
        for(var a=0;a<animations.length;a++)animations[a].currentTime=0;
      }
    }
  }

  var timer=0;
  function schedule(){
    clearTimeout(timer);
    timer=setTimeout(function(){
      fixCustomMarquee();
      fixJudge();
      [80,250,700,1500].forEach(function(delay){setTimeout(fixJudge,delay);});
    },40);
  }

  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',schedule,{once:true});
  else schedule();
  window.addEventListener('resize',schedule);
  document.addEventListener('shopify:section:load',schedule);
  document.addEventListener('click',schedule,true);
})();